import { ExecutionResult } from '@lcs/shared/api';
import { UserPostInput } from 'generated/graphql-types';
import { UserDetailSaveModel } from 'src/app/pages/user-details/models/user-detail-save.model';
import { SaveUser } from 'src/app/pages/user-details/queries/generated/SaveUser';

export function createUserInput(user: UserDetailSaveModel, userFields: (keyof UserPostInput)[]): UserPostInput {
   userFields = [...userFields, 'userId'];

   const fields: string[] = userFields;

   const userInput: UserPostInput = { fields, userId: user.userId };

   userFields.forEach((field) => {
      userInput[field.toString()] = user[field];
   });

   return userInput;
}

export type UserSaveResult = ExecutionResult<SaveUser>;
